/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Discriminator for the type of VMUA request contained in the encrypted payload.
 */
export type VmuaRequestTypeEnum = 'APPROVAL_REQUEST' | 'REGISTRATION_REQUEST' | 'UPDATE_REQUEST';

export const VmuaRequestTypeEnum = {

    APPROVAL_REQUEST: 'APPROVAL_REQUEST' as VmuaRequestTypeEnum,

    REGISTRATION_REQUEST: 'REGISTRATION_REQUEST' as VmuaRequestTypeEnum,

    UPDATE_REQUEST: 'UPDATE_REQUEST' as VmuaRequestTypeEnum
};

